import { Observer } from 'mobx-react';
import * as React from 'react';

import { FormModal } from '../components/FormModal';

import { openModalStore } from '../stores';

function Base() {
  return (
    <Observer>
      {() => {
        if (!openModalStore.value) return null;
        return <FormModal open={openModalStore.value} />;
      }}
    </Observer>
  );
}

export { Base };
